window._ = require("lodash");

try {
    window.Popper = require("popper.js").default;
    //window.$ = window.jQuery = require("jquery");

    require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.baseURL = "https://" + window.location.hostname;

import axiosRetry from "axios-retry";

axiosRetry(window.axios, {
    retries: 3, // number of retries
    retryDelay: (retryCount) => {
        //console.log(`retry attempt: ${retryCount}`);
        return retryCount * 2000; // time interval between retries
    },
    retryCondition: (error) => {
        // if retry condition is not specified, by default idempotent requests are retried

        return error.response.status != "undefined"
            ? error.response.status === 503
            : false;
    },
});

import store from "./store/index"; //so we can mutate the error response
// Add a request interceptor
window.axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
window.axios.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data

        return response.data.DATA;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        store.commit("ERROR", error);
        return Promise.reject(error);
    }
);
